import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { FormLogin } from './FormLogin';
import { FormRegister } from './FormRegister';
import { FormForgotPassword } from './FormForgotPassword';
import FormNYCULogin from './FormNYCULogin';

import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';

const recaptcha = '6LeHgVkmAAAAAO61PT6MmWpk0pVXMRZuXzgRNO1B';

export class TabLogin extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1'
    };
  }


  toggle(tab) {
    if (this.props.activeTab !== tab) {
      this.props.onTabChange(tab);
      this.setState({
        activeTab: tab
      });
    }
  }
  render() {
    const isRecaptchaEnabled = process.env.REACT_APP_ENABLE_RECAPTCHA === 'true';
    const content = (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.props.activeTab === '1' })}
              onClick={() => { this.toggle('1'); }}
            >
              一般登入
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.props.activeTab === '4' })}
              onClick={() => { this.toggle('4'); }}
            >
              NYCU登入
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2'); }}
            >
              註冊
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '3' })}
              onClick={() => { this.toggle('3'); }}
            >
              忘記密碼
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Card body>
                  <hr />
                  <CardText><FormLogin /></CardText>
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                <Card body>
                  <hr />
                  <CardText><FormRegister /></CardText>
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              <Col sm="12">
                <Card body>
                  <hr />
                  <CardText><FormForgotPassword /></CardText>
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="4">
            <Row>
              <Col sm="12">
                <Card body>
                  <hr />
                  <CardText><FormNYCULogin /></CardText>
                </Card>
              </Col>
            </Row>
          </TabPane>

        </TabContent>
      </div>
    );
    return isRecaptchaEnabled ? (
      <GoogleReCaptchaProvider reCaptchaKey={recaptcha}>
        {content}
      </GoogleReCaptchaProvider>
    ) : content;
  }
}
